import { ReportSummary as Component } from './component';
import Connector from './connector';
import { ConnectorReportSummaryProps } from './ReportSummary.proptype';

export interface ReportSummaryProps extends Omit<ConnectorReportSummaryProps, 'component'> {}

export const ReportSummary = (props: ReportSummaryProps) => <Connector {...props} component={Component} />;
